import { Download, Plus, RotateCcw } from "lucide-react";

export default function Header({ onExport, onAdd, onReset, exporting }) {
  return (
    <header className="sticky top-14 lg:top-0 z-30 border-b" style={{ borderColor: "var(--border)", background: "rgba(3,3,3,0.85)", backdropFilter: "blur(16px)" }}>
      <div className="max-w-[1600px] mx-auto px-5 md:px-8 py-4 flex flex-wrap items-center gap-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl grid place-items-center font-head font-extrabold text-lg" style={{ background: "var(--amber)", color: "#090a0f" }}>A</div>
          <div>
            <div className="eyebrow">Alchemist (CA) · Outreach Tracker</div>
            <h1 className="text-lg md:text-xl font-extrabold leading-tight" data-testid="app-title">ADE 2026 — Relationship-First Outreach</h1>
          </div>
        </div>
        <div className="mono text-xs px-3 py-1.5 rounded-full border hidden md:block" style={{ borderColor: "var(--border)", color: "var(--cyan)" }} data-testid="ade-dates-pill">
          AMSTERDAM · OCT 21 – 24, 2026
        </div>
        <div className="ml-auto flex items-center gap-2">
          <button className="btn btn-ghost btn-sm" onClick={onReset} data-testid="reset-data-button" title="Reset to the curated starting list">
            <RotateCcw size={14} /> Reset
          </button>
          <button className="btn" onClick={onAdd} data-testid="add-contact-button">
            <Plus size={15} /> Add target
          </button>
          <button className="btn btn-amber" onClick={onExport} disabled={exporting} data-testid="export-excel-button">
            <Download size={15} /> {exporting ? "Building…" : "Export Excel"}
          </button>
        </div>
      </div>
    </header>
  );
}
